<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default  {
  name:  'App',
}
</script>
<style>
/* 全局样式 */
* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* 防止整个页面出现横向滚动条 */
html, body {
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

#app {
  overflow-x: hidden;
  max-width: 100%;
  box-sizing: border-box;
}

/* 确保 MessageBox 在所有屏幕尺寸下都居中显示 */
.el-message-box {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
}

/* 窄屏时确保 MessageBox 仍然居中 */
@media (max-width: 420px) {
  .el-message-box {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    width: 90% !important;
    max-width: 90% !important;
  }
}
</style>
